<template>
  <v-card class="agency__profiles">
    <div class="text-center pt-4">
      <Avatar :initials="userInitials" light size="60" />
      <h5 class="mt-2">{{ userFullName }}</h5>
      <p class="secondary-text">{{ userEmail }}</p>
    </div>
    <v-divider />
    <h6 class="ml-6">Profiles</h6>
    <div>
      <p v-if="isImpersonating" class="secondary-text px-3">
        Disabled switch profile when impersonating
      </p>
      <v-radio-group class="radio" v-else>
        <div
          class="radio--standard"
          @click="setSelectedProfile(profile)"
          :class="{
            'radio--standard__active': isSelected(profile)
          }"
          v-for="(profile, index) in profiles"
          :key="`opt-${index}`"
          aria-label="Select profile"
        >
          <v-radio :value="profile.id" color="white">
            <template v-slot:label>
              <div>
                <h6 :class="{ 'mt-2': isWorker(profile.roles) }">
                  {{ profile.accountType | accountType }}
                </h6>
                <p
                  v-if="!isWorker(profile.roles)"
                  :class="{ 'font-italic': isSelected(profile) }"
                >
                  {{ profile.roles | roles }}
                </p>
              </div>
            </template>
          </v-radio>
        </div>
      </v-radio-group>
    </div>
  </v-card>
</template>

<script>
import { getNameInitials } from "@/utils/helpers";
import { getFullName, isWorker } from "@/utils/users";
import Avatar from "@/components/common/Avatar";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { SELECT_PROFILE } from "@/store/modules/auth/action-types";
import { size } from "lodash";
import { getImpersonateUserId } from "@/services/utils";

const { mapState, mapActions } = createNamespacedHelpers(AUTH_NAMESPACE);
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: { Avatar },
  computed: {
    ...mapState({
      selectedProfile: state => state.selectedProfile,
      profiles: state => state.profiles
    }),
    userInitials() {
      return getNameInitials(this.user);
    },
    userFullName() {
      return getFullName(this.user);
    },
    userEmail() {
      return this.user.email;
    },
    isImpersonating() {
      return Boolean(getImpersonateUserId());
    },
    selectedProfileId() {
      return this.selectedProfile.id;
    }
  },
  methods: {
    ...mapActions({
      selectProfile: SELECT_PROFILE
    }),
    setSelectedProfile(profile) {
      if (size(this.profiles) > 1 && this.selectedProfileId !== profile.id) {
        this.selectProfile({ profile, refresh: true });
      }
    },
    isSelected(profile) {
      return profile.id === this.selectedProfileId;
    },
    isWorker
  }
};
</script>

<style lang="scss">
.agency__profiles {
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    padding-bottom: 50px;
  }
  h6 {
    font-size: 16px;
    margin-bottom: 3px;
  }
  p {
    color: $secondary-text;
    font-size: 14px;
  }
  .radio {
    &--standard {
      padding: 0px 0px 10px 0px !important;
      background-color: #ffffff !important;
      border: none !important;
      margin: 0;

      h6,
      p {
        color: $secondary-text;
      }

      i {
        margin-bottom: 5px;
      }

      :hover {
        h6,
        p {
          color: $primary-text;
        }

        i {
          color: $primary;
        }
      }

      &__active {
        background-color: #ffffff !important;
        border: none !important;
        box-shadow: none !important;

        h6,
        p {
          color: $primary-text;
        }

        i {
          color: $primary;
        }
      }
    }
  }

  .radio .v-radio label {
    left: 5px;
    top: 12px;
    margin-right: 20px;
  }

  i.v-icon.notranslate.mdi.mdi-briefcase-outline.theme--light {
    display: inline-flex !important;
  }
}
</style>
